import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, Router, RouterStateSnapshot } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap';
import { Observable, of } from 'rxjs';
import { SolicitudServicioComponent } from '../../home/solicitud-servicio/solicitud-servicio.component';
import { ModalConfirmationComponent } from '../../utils/modal-confirmation/modal-confirmation.component';
import { AuthenticationService } from './authentication.service';
import { RequestStateService } from './request-state.service';
@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild, CanDeactivate<SolicitudServicioComponent> {
  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private requestStateService: RequestStateService,
    private modalService: BsModalService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.auth.isAuthenticated()) {
      if (state.url.indexOf('contenido:detalle') >= 0) {
        this.requestStateService.setLastUnauthorizedUrl(state.url);
      } else {
        this.requestStateService.clearLastUnauthorizedUrl();
      }
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }

  canDeactivate(component: SolicitudServicioComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    if (!component.unidades || component.unidades.length === 0) {
      return of(true);
    } else {
      const url: string = state.url;
      console.log('Url: ' + url);
      const modal = this.modalService.show(ModalConfirmationComponent);
      (<ModalConfirmationComponent>modal.content).showConfirmationModal(
        'Cambios sin guardar',
        'Si continúa perderá los datos no guardados. ¿Desea continuar?',
        '',
        'Sí',
        'No',
        true,
        'fa-question-circle fa-3x',
        'bg-warning'
      );
      return (<ModalConfirmationComponent>modal.content).onClose;
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
